export default __webpack_public_path__ + "static/media/blue-right-thin.85d60299.svg";